module.exports = __webpack_public_path__ + "img/packages/v1.e7c4f6.png";